module.exports = __webpack_public_path__ + "static/media/tick-check.52802ba5.png";